'use strict';

var React = require('react');

var SvgReceiptDollarIcon = function SvgReceiptDollarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.963 17.4a1.5 1.5 0 0 1-.963-1.4v-11a2.5 2.5 0 0 1 2.5-2.5h7a2.5 2.5 0 0 1 2.5 2.5v11a1.5 1.5 0 0 1-2.615 1.003l-1.135-1.26-1.135 1.26a1.5 1.5 0 0 1-2.23 0l-1.135-1.26-1.135 1.26a1.5 1.5 0 0 1-1.652.397Zm7.388-3.4h-.203a.995.995 0 0 0-.641.326l-1.507 1.674-1.507-1.674a.995.995 0 0 0-.641-.326h-.204a.995.995 0 0 0-.641.326l-1.507 1.674v-11a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v11l-1.507-1.674a.995.995 0 0 0-.642-.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 5a.75.75 0 0 0-.75.75v.25a2 2 0 1 0 0 4h1a.5.5 0 0 1 0 1h-2.25a.75.75 0 0 0 0 1.5h.75v.25a.75.75 0 0 0 1.5 0v-.25a2 2 0 1 0 0-4h-1a.5.5 0 0 1 0-1h2.25a.75.75 0 0 0 0-1.5h-.75v-.25a.75.75 0 0 0-.75-.75Z"
  }));
};
SvgReceiptDollarIcon.displayName = "ReceiptDollarIcon";

exports.SvgReceiptDollarIcon = SvgReceiptDollarIcon;
